export default {
  创作即收益: "クリエイトして、報酬を獲得",
  加入EBC创作者激励计划: "ハッピーパートナープログラムに参加して、あなたの影響力を収入に変えましょう。",
  成为创作者: "今すぐ始めよう",
  无限奖励: "ハッピーパートナープログラム",
  EBC创作者激励计划:
    "ハッピーパートナープログラムで、コンテンツをグローバルに展開し、毎月報酬を獲得しましょう。",
  推荐奖励: "紹介報酬",
  推荐新用户注册并交易: "新規ユーザーをトレードに招待して、毎月報酬を獲得しましょう。",
  内容变现: "コンテンツの収益化",
  在EBC: "高品質なコンテンツで安定した収益を獲得しましょう。",
  内容进阶: "グローバルな露出",
  从本地创作到全球影响: "インフルエンサーになって、世界中のオーディエンスとのエンゲージメントを高めましょう。",
  预计奖金: "月間報酬見込み",
  均值估算仅供参考: "*平均値が参考値のみです",
  "800万交易者的信任首选": "500万人のトレーダーに信頼される取引プラットフォーム",
  EBC用全球最佳券商的实力:
    "世界ベストのブローカーとして、私たちはあなたの影響力を収入に変え、特別な報酬とグローバルな機会へのアクセスを提供します。",
  全方位媒体曝光: "全面的なメディア露出",
  我们以全球媒体资源:
    "FCバルセロナのイベントや世界中のメディアチャンネルにアクセスして、パーソナルブランドと認知度を高めましょう。",
  全球最强交易环境: "世界最高の取引環境",
  打造极致交易体验:
    "ミリ秒単位の執行、機関投資家向けの流動性、そして優れたコピートレード機能で取引できます。",
  专属客户经理: "専任アカウントマネージャー",
  我们为每位创作者配专属运营:
    "質の高いコンテンツを作成し、サポートを獲得し、収益を最大化するためのサポートを提供します。",
  如何成为创作者: "パートナーになるには",
  从内容创作到奖励提现: "あらゆる段階で専属マネージャーからサポートを受けられます。",
  立即加入:"今すぐ参加",
  注册提交资料:"登録して詳細情報を提出",
  发布专业内容:"質の高いEBCコンテンツを作成・共有",
  获取月度奖励:"毎月の報酬を受け取る",
  活动须知:"プログラムガイドライン",
  notices:[
    "1.パートナーは、独立したコンテンツコラム、ソーシャルメディアアカウント、またはコミュニティチャンネルを持ち、少なくとも3ヶ月間継続してコンテンツを制作できる必要があります。コンテンツの形式には、戦略分析、グラフィック解釈、ビデオコースなどが含まれますが、これらに限定されません。",
    "2.コンテンツは、オリジナルで、プロフェッショナルであり、コンプライアンスに準拠している必要があります。盗作、無許可の書き換え、または禁止されたコンテンツの公開があった場合、EBCは参加および関連する特典を取り消すことができます",
    "3.クリエイターの達成度に基づいて毎月の決済が行われ、翌月第1週に資格を満たしたクリエイターに報酬が付与されます。",
    "4.このプログラムは、他のプログラム（シグナル提供者報酬プログラムや入金プログラムなど）とは併用できません。",
    `5.プラットフォームは、優秀なクリエイターに、コンテンツ支援やコンバージョンリソースを含む専用の運用サポートを提供します。ご不明な点がございましたら、お気軽にカスタマーサービス<a
                href="mailto:cs@ebc.com"
                >mkt@ebc.com</a
              >までお問い合わせください。`,
    "6.公平性を確保するため、EBCはこのプログラムの最終的な解釈権を留保し、いかなる形式の違反または濫用も失格とする場合があります。"
  ],
  section4Tips:"* 「World Finance」で3年連続受賞：2023年ベストFX取引プラットフォーム、2024年ベストCFDブローカー、2025年世界ベスト取引プラットフォーム、2025年世界で最も信頼されるブローカー。2025年「Online Money Awards」世界ベストCFDブローカー"
};
